/** @module Components */

import React from 'react'
import { EventPage } from '../EventPage'
import { event2025Data } from '../EventPage/data/2025'

export const PastEvent2025: React.FC = () => {
  return <EventPage data={event2025Data} />
}
